var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Button",
        { attrs: { size: "large", type: "text" }, on: { click: _vm.backHome } },
        [_vm._v("返回首页")]
      ),
      _c(
        "Button",
        { attrs: { size: "large", type: "text" }, on: { click: _vm.backPrev } },
        [_vm._v("返回上一页(" + _vm._s(_vm.second) + "s)")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }